import { createSlice } from "@reduxjs/toolkit";

const searchedpropertiesSlice = createSlice({
  name: "searchedproperties",
  initialState: {
    searchedProperties: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    setSearchResults: (state, action) => {
      state.searchedProperties = action.payload;
    },
    setSearchresultLoading: (state) => {
      state.status = "loading";
    },
    setSearchresultSucceeded: (state) => {
      state.status = "succeeded";
    },
    setSearchresultFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export const {
  setSearchResults,
  setSearchresultLoading,
  setSearchresultSucceeded,
  setSearchresultFailed,
} = searchedpropertiesSlice.actions;

export default searchedpropertiesSlice.reducer;
